import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { WizardWidgetComponent } from '../wizard-widget/wizard-widget.component';
import { TypesService, FormBuilderService } from '../../../services';
import { IndividualInvestmentIncomeModel } from '../../../models/widgets/investment-income-model';
import { ownershipValidator } from '../../../_global/validators/custom-validators.directive';

import _ from 'lodash';
import * as uuid from 'uuid';

import { BehaviorService } from '../../../services/behavior.service';
import {DataHandlerService} from '../../../services/data-handler.service';
import { OwnershipAllocationComponent } from '../ownership-allocation/ownership-allocation.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgIf, NgFor } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import {
  AddressSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/address-search/address-search.component';
import {
  MatInputCommifiedDirective
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/commified/mat-input-commified-directive';

@Component({
    selector: 'app-investment-income',
    templateUrl: './investment-income.component.html',
    styles: [],
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatFormFieldModule, NgIf,
      NgFor, MatCheckboxModule, MatCheckboxModule, MatButtonModule, MatButtonModule, MatIconModule, MatSelectModule, MatSelectModule,
      MatOptionModule, MatOptionModule, MatInputModule, MatInputModule, ValidationPartialComponent, MatTooltipModule,
      OwnershipAllocationComponent, AddressSearchComponent, MatInputCommifiedDirective]
})

export class InvestmentIncomeComponent extends WizardWidgetComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public personList: any;
  @Input() public companyList: any;
  @Input() public trustList: any;
  @Input() public isSMSF = false;
  @Input() public isFurtherAdvance = false;

  public isHomeLoan = false;
  public investmentsFormArray: UntypedFormArray;
  public allLenders = [];
  public removableFlags = [];

  public types: any = ['property-types', 'liability-types'];
  public propertyTypes: any;
  public liabilityTypes: any;
  public creditProviders: any;

  constructor(public dataHandlerService: DataHandlerService,
    private typesService: TypesService,
    private formBuilderService: FormBuilderService,
    private formBuilder: UntypedFormBuilder,
    private behaviorService: BehaviorService
  ) {
    super(dataHandlerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.initTypes();
    this.investmentsFormArray = this.formGroup.get('investmentList') as UntypedFormArray;

    this.isHomeLoan = (this.opts && this.opts.type === 'home-loan');

    if (this.investmentsFormArray && this.investmentsFormArray.value) {
      this.behaviorService.triggerRentalInvestmentsUpdated(this.investmentsFormArray.value);
    }

    (this.investmentsFormArray as UntypedFormArray).valueChanges.pipe(debounceTime(500)).subscribe((val) => {
      this.behaviorService.triggerRentalInvestmentsUpdated(val);
    });

    // set validations
    this.investmentsFormArray.controls.forEach((fg: UntypedFormGroup) => {
      this.formBuilderService.setValidationRules(new IndividualInvestmentIncomeModel(), fg);
      // this.initParties(fg);
    });

    this.behaviorService.rentalIncomeBehavior.subscribe((behavior) => {
      console.debug('InvestmentIncomeComponent.behaviorService.rentalIncomeBehavior');
      if (behavior === BehaviorService.ADD_RENTAL_INCOME_BEHAVIOR) {
        this.addInvestment();
      }
    });
  }

  removeInvestment(index) {
    const link = this.investmentsFormArray.controls[index].get('link').value;
    this.behaviorService.triggerRentalInvestmentsRemoved(link);
    this.investmentsFormArray.removeAt(index);
    this.dataHandlerService.sendAssetChange();
  }

  updateAddBackField(formGroup, value) {
    if (!formGroup.controls.invLoanIntAddback.touched) {
      formGroup.get('invLoanIntAddback').patchValue(value);
    }
  }

  addInvestment() {
    const investment = new IndividualInvestmentIncomeModel();
    const fg = this.formBuilderService.convertObjectToFormGroup(investment);
    fg.patchValue({ link: uuid.v1() }, { emitEvent: false });

    this.formBuilderService.setValidationRules(new IndividualInvestmentIncomeModel(), fg);

    fg.get('investmentLoanBalance').valueChanges
      .subscribe((value: any) => {
        console.debug('InvestmentIncomeComponent.investmentLoanBalance.valueChanges');
        this.updateAddBackField(fg, value);
      });

    this.investmentsFormArray.push(fg);
    this.dataHandlerService.sendAssetChange();
  }

  initParties(fg: UntypedFormGroup) {
    let initOwnershipValue = 100;

    if (this.personList.value.length > 1) {
      initOwnershipValue = 100 / this.personList.value.length;
    }
    const tempPartiesValue = fg.value.parties;
    const partiesFormControl = <UntypedFormArray>fg.get('parties');

    console.log('tempPartiesValue', tempPartiesValue);
    console.log('initOwnershipValue', initOwnershipValue);

    if (!this.isFurtherAdvance) {
      while (partiesFormControl.length) {
        partiesFormControl.removeAt(0);
      }
    }

    this.personList.value.forEach((borrower: any, idx) => {
      console.log('tempPartiesValue', _.get(tempPartiesValue, `${idx}.ownership`, initOwnershipValue));
      const ownershipValue = _.get(tempPartiesValue, `${idx}.ownership`, initOwnershipValue);

      partiesFormControl.push(this.formBuilder.group({
        name: new UntypedFormControl(borrower.firstName + ' ' + borrower.lastName),
        ownership: new UntypedFormControl(ownershipValue, [Validators.required]),
      }));
    });

    console.log('partiesFormControl', partiesFormControl);

    partiesFormControl.setValidators(ownershipValidator());
  }

  confirmReducedOwnership(formGroup) {
    formGroup.controls.parties.clearValidators();
    formGroup.controls.parties.updateValueAndValidity();
  }

  public initTypes() {
    const allTypes = this.types.map(t => this.typesService.getTypesList(t));
    Promise.all(allTypes).then((ret) => {
      this.types.forEach((t, idx) => {
        this[_.camelCase(t)] = ret[idx];
      });
    });
    this.populateLenders();
  }

  public populateLenders() {
    return this.typesService.getTypesList('credit-providers', 'ext.CompanyName')
      .then((results) => {
        this.allLenders = results.sort((a, b) => {
          return a.text - b.text;
        })
          .map((t) => {
            return {
              name: t.text,
              partyRoleId: t.id,
              partyId: t.ext.PartyID
            };
          });
      });
  }
}
